export const categories = [
  {
    slug: 'features',
    name: '功能介绍',
    description: '了解91浏览器的核心功能与特色亮点',
    icon: 'ri-smartphone-line',
  },
  {
    slug: 'tutorials',
    name: '使用教程',
    description: '从入门到精通，快速掌握91浏览器',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'download',
    name: '下载指引',
    description: '各平台下载安装91浏览器的详细步骤',
    icon: 'ri-download-2-line',
  },
  {
    slug: 'privacy',
    name: '隐私安全',
    description: '91浏览器如何保护您的在线隐私与数据安全',
    icon: 'ri-shield-check-line',
  },
];

export const categoryMeta: Record<string, { title: string; description: string; keywords: string }> = {
  features: {
    title: '91浏览器功能介绍 - 极速浏览·隐私保护·多端同步',
    description: '全面了解91浏览器的核心功能：极速浏览引擎、智能广告拦截、隐私保护模式、多端数据同步、个性化主题定制等特色功能，让您的上网体验更流畅、更安全。',
    keywords: '91浏览器功能介绍,91浏览器功能,极速浏览,隐私保护,多端同步,广告拦截',
  },
  tutorials: {
    title: '91浏览器使用教程 - 从入门到精通',
    description: '91浏览器详细使用教程：网页版登录指南、在线使用技巧、书签管理、历史记录同步、快捷键操作等完整教程，帮助您快速上手91浏览器。',
    keywords: '91浏览器使用教程,91浏览器怎么用,91浏览器教程,浏览器使用指南',
  },
  download: {
    title: '91浏览器官网下载 - Windows/Mac/Android/iOS',
    description: '91浏览器官网下载页面，提供Windows版、Mac版、Android版、iOS版等多平台最新版本下载，详细安装步骤指引，安全无毒，官方正版。',
    keywords: '91浏览器官网下载,91浏览器下载,91浏览器安装,浏览器下载',
  },
  privacy: {
    title: '91浏览器隐私保护 - 安全浏览·数据加密',
    description: '91浏览器隐私保护功能详解：无痕浏览模式、广告追踪拦截、HTTPS强制加密、密码管理器、指纹防护等，全方位保障您的在线隐私安全。',
    keywords: '91浏览器隐私保护,91浏览器安全,无痕浏览,数据加密,隐私安全',
  },
};